module.exports = __webpack_public_path__ + "img/searchIcon.7570d194.svg";